<template>
  <div>
    <TitleField :fieldName="FieldName.MRPA_BASE_AUTHORITY" />
    <div class="row-box">
      <WrapperField
        v-for="(fieldValue, fieldName) in orderedData"
        :key="fieldValue + fieldName + Math.random()"
        :data="
          createDataField({
            fieldName,
            fieldValue,
            fieldGroup: FieldGroup.MRPA_BASE_AUTHORITY,
          })
        "
      />
    </div>
  </div>
</template>

<script>
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import { StatementType } from '@/types/services';
import { FieldName } from '@/constants';

const defaultOrder = [
  FieldName.NAME,
  FieldName.AUTHORITY_INFO,
  FieldName.ISSUE_DATE,
  FieldName.ISSUER,
  FieldName.ISSUE_NUMBER,
  FieldName.REG_NUMBER,
];

export default {
  name: 'MrpaBaseAuthority',
  props: ['data', 'statementType'],
  components: {
    WrapperField,
    TitleField,
  },
  data: () => ({
    FieldGroup,
    FieldName,
    createDataField,
  }),
  computed: {
    order() {
      let orderedFields = defaultOrder;

      if (this.statementType === StatementType.ROD) {
        orderedFields = [
          FieldName.AUTHORITY_INFO,
          FieldName.ISSUE_DATE,
          FieldName.ISSUE_EXPIRATION_DATE,
          FieldName.ISSUE_NUMBER,
          FieldName.SYSTEM_ID,
        ];
      }

      if (this.data[FieldName.MRP_ISSUER_INN]) {
        orderedFields.push(FieldName.MRP_ISSUER_INN);
      }

      return orderedFields;
    },

    orderedData() {
      const res = {};

      this.order.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.data, key)) {
          res[key] = this.data[key];
        }
      });

      return res;
    },
  },
};
</script>
